import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CookiepolicyComponent } from './cookiepolicy/cookiepolicy.component';

import { ChangePasswordComponent } from './authentication/change-password/change-password.component';
import { ErrorComponent } from './error/error.component';
import { ListingComponent } from './dashboard/listing/listing.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './authentication/login/login.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import{ExtAuthenticationComponent} from "./ext-authentication/ext-authentication.component"


export const routes: Routes = [
  // { path: "", redirectTo: "login", pathMatch: "full" },
  // { path: "login", component: LoginComponent },
  // { path: "signin", component: LoginComponent },
  { path: "client", loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: "home", loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: "change-password", component: ChangePasswordComponent },
  { path: "cookie-policy", component: CookiepolicyComponent },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  { path: "error", component: ErrorComponent },
   { path: "errorscreen", component: ErrorComponent },
  //  { path: 'client/error', redirectTo: '/error', pathMatch: 'full' },
  //  { path: 'client/errorscreen', redirectTo: '/error', pathMatch: 'full' },
  { path: "logout", component: LogoutComponent },
 
  // { path: "ssoauth", loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: "ssoauth/appredirect", component: ExtAuthenticationComponent},
  { path: "ssoauth/signout", component: LogoutComponent},

    { path: '', redirectTo: 'client/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'client/login', pathMatch: 'full' },



  
];

